webpackJsonp([107818501498521],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/blog-post.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var context = _ref.context,
	      data = _ref.data;
	  var post = data.markdownRemark; // data.markdownRemark holds our post data
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Ooer - ' + post.frontmatter.title }),
	    _react2.default.createElement(
	      'nav',
	      { className: 'blog-section' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'blog-section-link newer-posts', to: '/' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\u2190'
	        ),
	        ' Home'
	      ),
	      _react2.default.createElement('span', { className: 'blog-section-link older-posts' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-post-container', style: { backgroundImage: post.frontmatter.bg } },
	      _react2.default.createElement(
	        'div',
	        { className: 'blog-post' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          post.frontmatter.title
	        ),
	        _react2.default.createElement('div', { className: 'blog-post-content', dangerouslySetInnerHTML: { __html: post.html } })
	      )
	    ),
	    _react2.default.createElement(
	      'nav',
	      { className: 'blog-section' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'blog-section-link newer-posts', to: '/' },
	        _react2.default.createElement(
	          'span',
	          { 'aria-hidden': 'true' },
	          '\u2190'
	        ),
	        ' Home'
	      ),
	      _react2.default.createElement('span', { className: 'blog-section-link older-posts' })
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-ef4de56d81eedd51528c.js